import { useCallback, useEffect, useState } from 'react';
import { ErroApi } from '../lib/api';
import { buscarIgreja, salvarIgreja, type DadosIgreja } from '../lib/financeiro';
import { Alerta, Botao, Campo, Cartao } from './Interface';

const VAZIO: DadosIgreja = { nome: '', cnpj: '', endereco: '', cidade: '', responsavel: '' };

export default function FinanceiroAjustes() {
  const [dados, setDados] = useState<DadosIgreja>(VAZIO);
  const [erro, setErro] = useState<string | null>(null);
  const [aviso, setAviso] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(async () => {
    try {
      const r = await buscarIgreja();
      setDados(r.igreja);
      setErro(null);
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui carregar os dados da igreja.');
    }
  }, []);

  useEffect(() => {
    void carregar();
  }, [carregar]);

  async function salvar() {
    setSalvando(true);
    setErro(null);
    setAviso(null);
    try {
      await salvarIgreja(dados);
      setAviso('Dados salvos. Os próximos documentos já saem com eles.');
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui salvar.');
    } finally {
      setSalvando(false);
    }
  }

  // `Campo` repassa as props padrao de <input>, entao value/onChange normais
  const campo = (chave: keyof DadosIgreja) => ({
    value: dados[chave],
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      setDados((d) => ({ ...d, [chave]: e.target.value })),
  });

  return (
    <div className="max-w-2xl space-y-4">
      {erro && <Alerta>{erro}</Alerta>}
      {aviso && <Alerta tipo="ok">{aviso}</Alerta>}

      <Cartao>
        <h2 className="font-semibold text-tinta-900">Dados da igreja</h2>
        <p className="mt-1 text-sm text-tinta-500">
          Aparecem no cabecalho dos recibos, do informe anual e da prestacao de contas. Recibo sem
          CNPJ nao serve para quem doou.
        </p>

        <div className="mt-4 space-y-3">
          <Campo rotulo="Nome" {...campo('nome')} />
          <Campo rotulo="CNPJ" {...campo('cnpj')} placeholder="00.000.000/0001-00" />
          <Campo rotulo="Endereco" {...campo('endereco')} />
          <Campo rotulo="Cidade" {...campo('cidade')} placeholder="Osasco/SP" />
          <Campo rotulo="Quem assina" {...campo('responsavel')} placeholder="Tesouraria" />
        </div>

        <div className="mt-4">
          <Botao carregando={salvando} onClick={() => void salvar()}>
            Salvar
          </Botao>
        </div>
      </Cartao>
    </div>
  );
}
